import { Switch } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { useApprovedVendorsActions } from 'companySettings/hooks';
import { NotificationPosition } from 'core/enums';

export const DefaultVendorCell = ({ value, data, node, api }: ICellRendererParams) => {
  const { upsertApprovedVendors } = useApprovedVendorsActions(NotificationPosition.TOP);

  const resetDefaultToFalse = (manufacturerId: number) => {
    api.forEachNode((node) => {
      if (node.data.manufacturerId === manufacturerId) {
        node.data.isDefault = 0;
        node.setData(node.data);
      }
    });
  };

  const onChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (data.isDefault) {
      return;
    }

    resetDefaultToFalse(data.manufacturerId);

    data.isDefault = event.target.checked ? 1 : 0;
    node.setData(data);

    await upsertApprovedVendors([data]);
  };

  return <Switch checked={Boolean(value)} onChange={onChange} />;
};
